import React from "react";
import {Breadcrumb} from "antd";
import {HomeOutlined} from "@ant-design/icons";
import {Link, NavLink} from "react-router-dom";
import {hideHeader, RouteConfig} from "../../router";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import {withRouter} from "react-router-dom";

function itemRender(route, params, routes, paths) {
    const last = routes.indexOf(route) === routes.length - 1;
    return last ? (
        <span>{route.breadcrumbName}</span>
    ) : (
        <Link to={paths.join('/')}>{route.breadcrumbName}</Link>
    );
}

const AppBreadcrumbs = withRouter(({history}) =>
{
    const breadcrumbs = useReactRouterBreadcrumbs(RouteConfig)
    const navigateTo = (path) => () => history.push(path)
    return <Breadcrumb style={{ margin: '16px 0' }}>

        {
            breadcrumbs
                //.filter(({match}) => match.url != '/' )
                .map(({match, breadcrumb}) => <Breadcrumb.Item key={'/#' + (match.url || '/')} onClick={navigateTo(match.url)}>
                    {breadcrumb}
                </Breadcrumb.Item>)}
    </Breadcrumb>

})


export default AppBreadcrumbs

